module.exports = __webpack_public_path__ + "img/zoom_in.83c19576.svg";